module.exports = __webpack_public_path__ + "static/media/Calendar.21266868.png";